import { createFindOrFetchForDomainHook } from "../../_utils/createFindOrFetchForDomainHook";
import type { SubscriptionId } from "@gs/core/domain/Subscription/Subscription";
import { subscriptionApi } from "domain/subscription/subscriptionApi";
import { useSubscriptionStore } from "domain/subscription/subscriptionStore";

export const useFindOrFetchSubscription = createFindOrFetchForDomainHook({
  fetch: (ids: SubscriptionId[]) => subscriptionApi.getSubscriptions({ limit: ids.length, offset: 0, teamLevel: true, filter: { id: ids } }),
  useStore: useSubscriptionStore,
});
